// db/enums.ts
var PageStatus = /* @__PURE__ */ ((PageStatus2) => {
  PageStatus2["IN_PROGRESS"] = "in progress";
  PageStatus2["PUBLISHED"] = "published";
  return PageStatus2;
})(PageStatus || {});
export {
  PageStatus
};
